import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const KoreaLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.ASIA,
  CODE: 'kr',
  LANGUAGE_CODE: 'ko',

  LONG_NAME: 'Korea',
  SHORT_NAME: 'KO',

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',
  DISPLAY_NAME: '한국',
  DISPLAY_COUNTRY: '한국',

  LANGUAGES: {
    KO: 'ko',
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 33.92920123358008,
    INITIAL_LONGITUDE: 138.42930714999994,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {},

  HOME_PAGE_URL: 'https://www.uniqlo.com',

  MAP_URL: 'https://www.uniqlo.com/kr/shop/',
  MAP_MOBILE_URL: 'https://map.uniqlo.com/kr/ko/',

  TERMS_OF_USE_URL: 'https://www.uniqlo.com',
  PRIVACY_POLICY_URL: 'https://www.uniqlo.com',

  POSTCODE_FORMAT: /[0-9]{5}/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default KoreaLocale
